import userSaga from "@redux/saga/user.saga";
import { Table, Row, Col, Input, Pagination, Button, notification, Checkbox, Empty } from "antd";
import React, { useEffect, useState } from "react";
import { getDeviceApps } from "../../axios/api.device";
import{ gaEvent} from "../../withTracker"

import { useTranslation } from "react-i18next";

const { Column } = Table;

interface propsModel {
  id: string,
  platform: string,
  deviceType: string
}

export const DeviceDetailApps = (props: propsModel) => {
  // const data = new Array(10).fill({ a: 1 });
  const { id, platform, deviceType } = props;
  const [data, setData] = useState<any[]>();
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [search, setSearch] = useState<string>("");
  const [appTypes, setAppTypes] = useState(["app"]);

  const { t } = useTranslation();

  useEffect(() => {
    if (id) {
      getData();
    }
  }, []);

  const getData = (index = pageIndex, size = pageSize, types = appTypes) => {
    getDeviceApps(
      id, 
      {
        pageIndex: index, 
        pageSize: size, 
        search: search, 
        appTypes: (platform == "IOS" || platform == "macOS") ? types.join() : "",
        deviceType: deviceType
      }
    ).then(
      (res) => {
        setPageIndex(res.pageIndex);
        setPageSize(res.pageSize);
        setData(res.dataList);
        setTotalCount(res.totalCount);
        if (platform == "IOS" || platform == "macOS") {
          setAppTypes(types);
        }
      },
      (e) => { notification.error({message: e.message}) }
    );
  };

  const onChangeAppType = (checkedValues: any[]) => {
    getData(1, pageSize, checkedValues);
  }

  return (
    <>
      <Row className="mb-2">
        <Col><span style={{lineHeight: "32px", marginRight: "5px"}}>{t("应用名称")}:</span></Col>
        <Col>
          <Input
            placeholder={t("输入名称搜索")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          ></Input>
        </Col>
        <Col>
          <Button type="primary" onClick={() =>{ getData(1);}}>{t("搜索")}</Button>
        </Col>
        {/* {
          (platform == "IOS" || platform == "macOS") && 
          <Col style={{lineHeight: "32px", marginLeft: "10px"}}>
            <Checkbox.Group 
              options={[
                {label: t('系统应用'), value: 'native'},
                {label: t('安装应用'), value: 'app'},
              ]} 
              defaultValue={appTypes} 
              onChange={onChangeAppType}
            ></Checkbox.Group>
          </Col>
        } */}
      </Row>
      <Table 
        dataSource={data} 
        rowKey="packageName" 
        pagination={false} 
        size="small"
        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
      >
        <Column title={t("图标")}  key="icon" dataIndex="icon"  render={(v)=>(
          <>
            {v &&(
              <img style={{width:40}} src={v}></img>
            )}
            {!v &&(
              <img style={{width:40}} src="/images/appIcon.png"></img>
            )}
          </>
        )}></Column>
        <Column title={t("名称")} key="appName" dataIndex="appName"></Column>
        <Column title={t("大小")} key="appSize" dataIndex="appSize"></Column>
        <Column title={t("版本")} key="appVersion" dataIndex="appVersion"></Column>
        <Column title={t("包名")} key="packageName" dataIndex="packageName"></Column>
        {platform!="Android" &&(
          <Column title={t("受管理App")} key="isManaged" dataIndex="isManaged" render={(r)=>r?t("是"):t("否")}></Column>
        )}
        
      </Table>
      <Pagination
        style={{ textAlign: "right", marginTop: "20px" }}
        pageSize={pageSize}
        current={pageIndex}
        total={totalCount}
        showTotal={(total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}`}
        onChange={(page, pageSize) => {
          getData(page, pageSize);
        }}
        onShowSizeChange={(current, size) => getData(current, size)}
      ></Pagination>
    </>
  );
};
